import { Modal, Select, Typography, message } from 'antd';
import { useEffect, useState } from 'react';
import tw from 'twin.macro';

import StatusBadge from '@/components/order/StatusBadge';
import { PRODUCT_ORDER_STATUS } from '@/constants';
import { useUpdateOrderStatus } from '@/hooks/mutations/admin';
import { useAdminProductOrder } from '@/hooks/queries/admin';

interface Props {
  isOpen: boolean;
  onClose: () => void;
  orderId: number;
  onSuccess: () => void;
}

const UpdateOrderStatusModal = ({
  onClose,
  onSuccess,
  isOpen,
  orderId,
}: Props) => {
  const query = useAdminProductOrder({ id: orderId }, { enabled: !!orderId });
  const updateOrderStatus = useUpdateOrderStatus({
    onSuccess: () => {
      message.success('신청 상태가 변경됐어요');
      onSuccess();
      onClose();
    },
  });

  const [status, setStatus] = useState<keyof typeof PRODUCT_ORDER_STATUS>(
    query.data?.status || 'HOLD'
  );

  useEffect(() => {
    if (query.data) {
      setStatus(query.data.status);
    }
  }, [query.data]);

  if (!query.data) {
    return null;
  }

  return (
    <Modal
      centered
      width={412}
      open={isOpen}
      onClose={onClose}
      onCancel={onClose}
      okButtonProps={{
        disabled: status === query.data?.status,
      }}
      onOk={() => {
        updateOrderStatus.mutate({
          id: orderId,
          status,
        });
      }}
      okText="변경"
      title="상태 변경"
    >
      <div css={tw`flex flex-row items-center gap-[12px]`}>
        <Typography.Text>신청 상태:</Typography.Text>

        <Select
          placeholder="선택"
          defaultValue={query.data.status}
          value={status}
          onChange={setStatus}
          options={(
            Object.keys(
              PRODUCT_ORDER_STATUS
            ) as (keyof typeof PRODUCT_ORDER_STATUS)[]
          ).map((value) => ({
            label: <StatusBadge status={value} />,
            value,
          }))}
        />
      </div>
    </Modal>
  );
};

export default UpdateOrderStatusModal;
